import axios, { Method } from "axios";

export const HttpMethods: { [key: string]: Method } = {
  GET: "GET",
  DELETE: "DELETE",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  OPTIONS: "OPTIONS",
};

export const baseUrl = {
  APP: "/app/v0/api",
  SHERPA: "/sherpa/v0/api",
  ROVER: "",
  SABACUS: "",
  VENDOR: "",
};

//Below instance does not work properly with session auth
//Backend needs to change to support below instance
export const appAxios = axios.create({
  baseURL: baseUrl.APP,
});

export const sherpaAxios = axios.create({
  baseURL: baseUrl.SHERPA,
});

export const roverAxios = axios.create({
  baseURL: baseUrl.ROVER,
});

export const sabacusAxios = axios.create({
  baseURL: baseUrl.SABACUS,
});
